<template>
    <div class="mainDiv">
        <div class="locationDiv">
            <v-select  label="Select"   :items="['California', 'Colorado', 'Florida', 'Georgia', 'Texas', 'Wyoming']">
                   
                </v-select>
 
        </div>
        <div class="startDateDiv">1 Apr 2019</div>
        <div class="endDtaeDiv">9 Mar 2023</div>
        <div class="searchInputDiv">Name, Business, Interest...</div>
        <div class="SearchDiv"> <p clas> Search</p></div>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";

export default {
    components: { Multiselect },
    name: "filterDiv",
    data() {
        return {
            value: null,
            options: ["list", "of", "options"],
        };
    },
};
</script>
<style lang="scss" scoped>
.mainDiv {
    height: 96px;
    background: #ffffff;
    display: flex;
    padding: 24px;
    column-gap: 5%;
    box-shadow: 1px 1px 1px rgba(17, 58, 34, 0.07);
    border-radius: 5px;
    margin-bottom: 48px;
}
.locationDiv {
    background: #ffffff;
    border: 1px solid rgba(121, 126, 121, 0.5);
    border-radius: 5px;
    width: 15%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.startDateDiv {
    background: #ffffff;
    border: 1px solid rgba(121, 126, 121, 0.5);
    border-radius: 5px;
    width: 15%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.endDtaeDiv {
    background: #ffffff;
    border: 1px solid rgba(121, 126, 121, 0.5);
    border-radius: 5px;
    width: 15%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.searchInputDiv {
    background: #ffffff;
    border: 1px solid rgba(121, 126, 121, 0.5);
    border-radius: 5px;
    width: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.SearchDiv {
    width: 15%;
    height: 56px;
    /* Primary */

    background: #339137;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
